import CoreTwoColumnLayout from './CoreTwoColumnLayout';

export { type CoreTwoColumnLayoutProps } from './CoreTwoColumnLayout';
export default CoreTwoColumnLayout;
